import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './CategoryHeader.module.less';
import {
  getGameCategoryTag,
  setGameCategoryTag,
  setGameCode,
  setShowCategoryTag,
  clearTag,
  setAppSort,
} from '../../../../actions/game';
import screenImg from '../../../../static/game/screen.png';
import hoverScreenImg from '../../../../static/game/hover_screen.png';
import { logging, logPostInfo } from '../../../../actions/log';
import arrowheadImg from '../../../../static/game/game_arrowhead.png';

const SelectGameTag = createSelector(
  state => state.game,
  game => game.categoryTag,
);

const SelectGameSelectCode = createSelector(
  state => state.game,
  game => game.gameSelectCode,
);

const SelectGameSort = createSelector(
  state => state.game,
  game => game.gameSort,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const sortOrder = [
  { id: 1, name: '下载量' },
  { id: 2, name: '热门' },
  { id: 3, name: '更新时间' },
  { id: 4, name: '好评率' },
];

export default memo(() => {
  const dispatch = useDispatch();
  const gameTag = useSelector(SelectGameTag);
  const gameCode = useSelector(SelectGameSelectCode);
  // const [activeCode, setActiveCode] = useState(gameCode);
  const gameSort = useSelector(SelectGameSort);
  // const [sortActive, setSortActive] = useState(gameSort);
  const [showList, setShowList] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    dispatch(getGameCategoryTag());
  }, []);

  useEffect(() => {
    dispatch(setShowCategoryTag(gameCode));
  }, [gameTag, gameCode]);

  const handleCode = useCallback(
    code => {
      // setActiveCode(code);
      dispatch(setGameCategoryTag(true));
      dispatch(setGameCode(code));
      dispatch(clearTag());
    },
    [gameCode],
  );

  const handleSort = id => {
    dispatch(setAppSort(id));
    dispatch(
      logging({
        category: 'C',
        action: 'Game_Base_Sizer',
        label: '',
        param2: {
          source: 'Game_Base',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          value: id,
          type: 'sort',
        },
      }),
    );
  };

  return (
    <div className={styles.category_header}>
      <div className="category_top">
        <div className="top_tag_list">
          {gameTag.map((tag, index) => (
            <div
              key={index}
              onClick={() => handleCode(tag.code)}
              className={`top_tag ${gameCode === tag.code ? 'top_tag_active' : ''}`}
            >
              {tag.code === '1' ? 'PC游戏' : '手机游戏'}
            </div>
          ))}
        </div>
        <div className="top_screen">
          <div
            className="screen_drop_down"
            onMouseEnter={() => {
              setShowList(true);
            }}
            onMouseLeave={() => {
              setShowList(false);
            }}
          >
            <div className="screen_selected">按{sortOrder[gameSort - 1].name}</div>
            {/* <i className="iconfont icon-arrow_down_small" /> */}
            <img src={arrowheadImg} className="arrowhead" />
            {showList && (
              <div className="drop_down_list">
                {sortOrder.map(orderItem => (
                  <div
                    key={orderItem.id}
                    className={`drop_down_item ${
                      gameSort === orderItem.id ? 'drop_down_item_active' : ''
                    }`}
                    onClick={() => handleSort(orderItem.id)}
                  >
                    {orderItem.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div
            className="open_screen"
            onClick={() => dispatch(setGameCategoryTag(true))}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
          >
            <img src={isHover ? hoverScreenImg : screenImg} />
            <div>筛选</div>
          </div>
        </div>
      </div>
    </div>
  );
});
